import { memo, ReactNode, useCallback, useState } from 'react';
import clsx from 'clsx';
import { Button } from '../Button/Button';
import { useOutsideClick } from '../../hooks/useOutsideClick';

type Props = {
    label?: ReactNode;
    icon: ReactNode;
    buttonSize?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
    kind?: 'tertiary' | 'primary' | 'secondary' | 'ghost' | 'danger';
    children: ReactNode;
}

export const OverflowMenu = memo(({ label, icon, kind = 'tertiary', buttonSize, children }: Props) => {
    const [opened, setOpened] = useState(false);

    const handleButtonClose = useCallback(() => {
        setOpened(false);
    }, []);

    const ref = useOutsideClick<HTMLDivElement>(handleButtonClose);

    const handleButtonToggle = useCallback(() => {
        setOpened((prev) => !prev);
    }, []);

    return (
        <div ref={ref} className={clsx({ 'vss-overflow-menu': true, 'vss-overflow-menu--opened': opened })}>
            <Button
                kind={kind}
                size={buttonSize}
                className="vss-overflow-menu__button"
                iconOnly={!label}
                onClick={handleButtonToggle}
            >
                {label}

                <div className="vss-overflow-menu__button-icon">
                    {icon}
                </div>
            </Button>

            <div className="vss-overflow-menu__list">
                {children}
            </div>
        </div>
    );
});
